import { I18n } from '@lingui/core'
import { instanceOf } from 'prop-types'

const i18nType = instanceOf(I18n)

export { i18nType }
